/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber3Small = createReactComponent("number-3-small", "IconNumber3Small", [
  [
    "path",
    {
      d: "M10 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5",
      key: "svg-0"
    }
  ]
]);

export { IconNumber3Small as default };
//# sourceMappingURL=IconNumber3Small.js.map
